// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"7213e022","618":"1765023f"}[chunkId] + ".chunk.js";
};